import { ProjectModel } from 'api-hooks/projects';
import { generateId } from 'common/utils/string';
import { customerMultiTransformer } from 'legacy-modules/master/customer/components/customer-multi-input';
import { guestMultiTransformer } from 'legacy-modules/master/guest/components/guest-multi-input';
import { salesMultiTransformer } from 'legacy-modules/sales/component/sales-multi-input';
import React from 'react';

import { ProjectFormType } from '../component/form-type';

export default function useGetDefaultValues(project?: ProjectModel) {
  const defaultValues = React.useMemo<ProjectFormType>(() => {
    return {
      code: project?.code || '',
      description: project?.description || '',
      name: project?.name || '',
      projectCustomers:
        project?.projectCustomers?.map((pc) => {
          return customerMultiTransformer(pc.customer) as any;
        }) ?? [],
      projectGuests:
        project?.projectGuests?.map((pg) => {
          return guestMultiTransformer(pg.guest) as any;
        }) ?? [],
      projectItineraries:
        project?.projectItineraries?.map((pi) => {
          return {
            date: pi.date,
            description: pi.description,
            id: pi.id,
            isComplete: pi.isComplete,
            route: pi.route,
            customId: generateId(),
          };
        }) ?? [],
      sales:
        project?.sales?.map((sale) => {
          return salesMultiTransformer(sale) as any;
        }) ?? [],
    };
  }, [project]);

  return defaultValues;
}
